import { useContext } from "react";
import FrontendContext from "../contexts/FrontendProvider";

const useFrontend = () => {
  return useContext(FrontendContext);
};

export default useFrontend;
